<template>
  <div>
    <div style="margin: 10px 0">
      <el-input style="width: 200px" placeholder="请输入亮点名称" suffix-icon="el-icon-search" v-model="name"></el-input>
      <el-select v-model="type" placeholder="请选择类型" style="width: 200px" class="ml-5">
        <el-option label="高级亮点" value="高级亮点"></el-option>
        <el-option label="文字识别" value="文字识别"></el-option>
        <el-option label="图片识别" value="图片识别"></el-option>
      </el-select>
      <el-select v-model="status" placeholder="请选择状态" style="width: 200px" class="ml-5">
        <el-option label="上架" :value="1"></el-option>
        <el-option label="下架" :value="2"></el-option>
      </el-select>
      <el-button class="ml-5" type="primary" @click="load">搜索</el-button>
      <el-button type="warning" @click="reset">重置</el-button>
    </div>

    <div style="margin: 10px 0">
      <el-button type="primary" @click="handleAdd">新增 <i class="el-icon-circle-plus-outline"></i></el-button>
      <el-popconfirm
          class="ml-5"
          confirm-button-text='确定'
          cancel-button-text='我再想想'
          icon="el-icon-info"
          icon-color="red"
          title="您确定批量删除这些数据吗？"
          @confirm="delBatch"
      >
        <el-button type="danger" slot="reference">批量删除 <i class="el-icon-remove-outline"></i></el-button>
      </el-popconfirm>
    </div>

    <el-table :data="tableData" border stripe :header-cell-class-name="'headerBg'"
              @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="45" align="center"></el-table-column>
      <el-table-column prop="name" label="亮点名称" width="150"></el-table-column>
      <el-table-column prop="type" label="类型" width="120"></el-table-column>
      <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
      <el-table-column label="封面" width="120">
        <template slot-scope="scope">
          <el-image
              style="width: 100px; height: 60px"
              :src="scope.row.coverPath"
              :preview-src-list="[scope.row.coverPath]"
              fit="cover">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
            {{ scope.row.status === 1 ? '上架' : '下架' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>

      <el-table-column label="操作" width="250" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="handleDetails(scope.row)">详情 <i class="el-icon-document"></i></el-button>
          <el-button type="success" @click="handleEdit(scope.row)">编辑 <i class="el-icon-edit"></i></el-button>
          <el-popconfirm
              class="ml-5"
              confirm-button-text='确定'
              cancel-button-text='我再想想'
              icon="el-icon-info"
              icon-color="red"
              title="您确定删除吗？"
              @confirm="del(scope.row.id)"
          >
            <el-button type="danger" slot="reference">删除 <i class="el-icon-remove-outline"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div style="padding: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[2, 5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <el-dialog title="亮点信息" :visible.sync="dialogFormVisible" width="50%" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="small">
        <el-form-item label="亮点名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入亮点名称"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型" style="width: 100%">
            <el-option label="高级亮点" value="高级亮点"></el-option>
            <el-option label="文字识别" value="文字识别"></el-option>
            <el-option label="图片识别" value="图片识别"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="form.description" type="textarea" :rows="2" placeholder="请输入描述"></el-input>
        </el-form-item>
        <el-form-item label="详情" prop="details">
          <mavon-editor v-model="form.details" style="height: 300px"/>
        </el-form-item>
        <el-form-item label="封面" prop="coverPath">
          <el-upload
              class="avatar-uploader"
              action="http://localhost:9090/file/upload"
              :show-file-list="false"
              :on-success="handleCoverSuccess">
            <img v-if="form.coverPath" :src="form.coverPath" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 详情抽屉 -->
    <el-drawer
        title="亮点详情"
        :visible.sync="drawerVisible"
        direction="rtl"
        size="70%">
      <div style="padding:0 20px;">
        <div class="detail-item">
          <h3>{{ currentRow.name }}</h3>
          <div class="detail-meta">
            <el-tag>{{ currentRow.type }}</el-tag>
            <el-tag :type="currentRow.status === 1 ? 'success' : 'info'" class="ml-5">
              {{ currentRow.status === 1 ? '上架' : '下架' }}
            </el-tag>
            <span class="create-time">创建时间：{{ currentRow.createTime }}</span>
          </div>
          <div class="detail-description">
            <h4>描述</h4>
            <p>{{ currentRow.description }}</p>
          </div>
          <mavon-editor
              class="md"
              :value="currentRow.details"
              :subfield="false"
              :defaultOpen="'preview'"
              :toolbarsFlag="false"
              :editable="false"
              :scrollStyle="true"
              :ishljs="true"
          />
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "Highlights",
  data() {
    return {
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      name: "",
      type: "",
      status: "",
      form: {
        id: '',
        name: '',
        type: '',
        description: '',
        details: '',
        coverPath: '',
        status: 1
      },
      rules: {
        name: [{required: true, message: '请输入亮点名称', trigger: 'blur'}],
        type: [{required: true, message: '请选择类型', trigger: 'change'}],
        description: [{required: true, message: '请输入描述', trigger: 'blur'}],
        details: [{required: true, message: '请输入详情', trigger: 'blur'}],
        coverPath: [{required: true, message: '请上传封面图片', trigger: 'change'}],
        status: [{required: true, message: '请选择状态', trigger: 'change'}]
      },
      dialogFormVisible: false,
      drawerVisible: false,
      multipleSelection: [],
      currentRow: {},
    }
  },
  computed: {
    markedDetails() {
      return this.currentRow.details ? marked(this.currentRow.details) : ''
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.request.get("/highlights/page", {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          name: this.name,
          type: this.type,
          status: this.status
        }
      }).then(res => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.request.post("/highlights", this.form).then(res => {
            if (res.code === '200') {
              this.$message.success("保存成功")
              this.dialogFormVisible = false
              this.load()
            } else {
              this.$message.error("保存失败")
            }
          })
        }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form = {
        name: '',
        type: '',
        description: '',
        details: '',
        coverPath: '',
        status: 1
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    handleEdit(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogFormVisible = true
    },
    handleDetails(row) {
      this.currentRow = row
      this.drawerVisible = true
    },
    handleCoverSuccess(res) {
      this.form.coverPath = res
      this.$message.success("上传成功")
    },
    del(id) {
      this.request.delete("/highlights/" + id).then(res => {
        if (res.code === '200') {
          this.$message.success("删除成功")
          this.load()
        } else {
          this.$message.error("删除失败")
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    delBatch() {
      if (!this.multipleSelection.length) {
        this.$message.error("请选择需要删除的数据")
        return
      }
      let ids = this.multipleSelection.map(v => v.id)
      this.request.post("/highlights/del/batch", ids).then(res => {
        if (res.code === '200') {
          this.$message.success("批量删除成功")
          this.load()
        } else {
          this.$message.error("批量删除失败")
        }
      })
    },
    reset() {
      this.name = ""
      this.type = ""
      this.status = ""
      this.load()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.load()
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum
      this.load()
    }
  }
}
</script>

<style>
.headerBg {
  background: #eee !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.detail-item {
  padding: 20px;
}

.detail-meta {
  margin: 15px 0;
}

.create-time {
  color: #999;
  margin-left: 15px;
}

.detail-cover {
  margin: 20px 0;
}

.detail-description {
  margin: 20px 0;
}

.detail-description h4,
.detail-content h4 {
  margin-bottom: 10px;
  color: #333;
}

.detail-content {
  margin: 20px 0;
}
</style>
